"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const FlowEdit_vue_1 = __importDefault(require("@/components/data/FlowEdit.vue"));
const litigation_1 = __importDefault(require("@/pages/index/api/litigation"));
const utils_1 = require("@/config/utils");
const mainData_1 = __importDefault(require("../mainData"));
const LogInfo_vue_1 = __importDefault(require("./../../components/LogInfo.vue"));
const seizeFlowConfig_1 = __importDefault(require("../seizeFlowConfig"));
let fromPath = '';
exports.default = (0, vue_1.defineComponent)({
    name: 'SeizeInfo',
    components: {
        FlowEdit: FlowEdit_vue_1.default,
        LogInfo: LogInfo_vue_1.default
    },
    data() {
        return {
            mainData: mainData_1.default,
            detail: undefined,
            flow: {
                data: seizeFlowConfig_1.default,
                key: undefined
            }
        };
    },
    beforeRouteEnter(to, from) {
        // 在渲染该组件的对应路由被验证前调用
        // 不能获取组件实例 `this` ！
        // 因为当守卫执行时，组件实例还没被创建！
        fromPath = from.fullPath !== '/' ? from.fullPath : '';
    },
    computed: {
        id() {
            return this.$route.params.id === 'build' ? undefined : this.$route.params.id;
        },
        litigationRecordId() {
            var _a;
            return (_a = this.detail) === null || _a === void 0 ? void 0 : _a.litigationRecordId;
        },
        isOperating() {
            return this.mainData.$getStatus('operate') === 'ing';
        },
        currentParams() {
            const params = this.$route.params;
            // console.log('flowKey = \'ufo_cs_zx_50\'')
            // return {
            //   flowId: simpleDecrypt(params.flowId as string),
            //   flowKey: 'ufo_cs_zx_50'
            // }
            return {
                flowId: (0, utils_1.simpleDecrypt)(params.flowId),
                flowKey: (0, utils_1.simpleDecrypt)(params.flowKey)
            };
        },
        isFinished() {
            if (this.id && this.detail) {
                return this.detail.applyStatus.status !== 'ing';
            }
            else {
                return false;
            }
        }
    },
    watch: {
        id() {
            this.$nextTick(() => {
                this.init();
            });
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.detail = undefined;
            const flowEdit = this.$refs['flow-edit'];
            if (this.id) {
                litigation_1.default.litigationSeizeInfo.require({
                    id: this.id
                }).then(res => {
                    const detail = this.mainData.$createDataByDictionary(res.data.data);
                    this.detail = detail;
                    this.flow.key = this.currentParams.flowKey;
                    flowEdit.init(this.flow.key, this.detail);
                });
            }
            else {
                flowEdit.init(this.flow.key, this.detail);
            }
        },
        onBack(toFrom) {
            if (fromPath && toFrom) {
                // 存在来源路径切需要跳转回来源时，通过back回退
                this.$router.replace(fromPath);
            }
            else {
                this.$router.replace('/home');
            }
        }
    }
});
